export default __webpack_public_path__ + "public/images/icons/check_circle.svg";